import React, { useEffect, useState } from "react";
import TextOnPicture from "./TextOnPicture";
import PhotoOnTop from "./PhotoOnTop";
import PhotoOnLeft from "./PhotoOnLeft";

interface IArticleList {
  articles: {
    currentPage: string;
    pages: number;
    posts: any[];
  };
}

const ArticleList: React.FC<IArticleList> = ({ articles }) => {

  const isDesktop = window.innerWidth > 996;

  const posts = Array.isArray(articles?.posts) ? articles.posts : [];

  if (posts.length === 0) {
    return <h2>Nie znaleziono żadnych artykułów</h2>;
  }

  const slices = [posts.slice(0, 3), posts.slice(3)];

  return (
    <>
      {slices.map((slice, sliceNo) => (
        <div className="row" key={sliceNo}>
          {slice.map((item, index) => (
            <div
              key={item.OID ?? index}
              className={
                "col-xs-12 col-md-" + (sliceNo === 0 && index === 0 ? 6 : 3)
              }
            >
              {sliceNo === 0 && index === 0 ? (
                isDesktop ? (
                  <TextOnPicture article={item} />
                ) : (
                  <PhotoOnTop article={item} />
                )
              ) : isDesktop ? (
                <PhotoOnTop article={item} />
              ) : (
                <PhotoOnLeft article={item} boxSize="xs" />
              )}
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default ArticleList;
